import { minServingFields } from 'constants';
import { getNetworkAndDirectBuyNames } from 'utils';

const CONFIG = {
  CPI: { max: 30, min: 0.01 },
  eCPM: { max: 5, min: 0.001 },
};

function validateInput(value, min, max, label) {
  if (!value) return true;
  const num = parseFloat(value);
  if (isNaN(num)) return `Must be a number`;
  if (num < min) return `Minimum ${label} is ${min}`;
  if (num > max) return `Maximum ${label} is ${max}`;
  return true;
}

export const validateCPI = {
  validate: (value) => validateInput(value, CONFIG.CPI.min, CONFIG.CPI.max, 'CPI'),
};

export const validateeCPM = {
  validate: (value) => validateInput(value, CONFIG.eCPM.min, CONFIG.eCPM.max, 'eCPM'),
};

export function validateCountries(formData, setError) {
  const { networkField, networkCountriesError, directBuyField, directBuyCountriesError } =
    getNetworkAndDirectBuyNames(minServingFields);

  let errorIdNetwork = '';
  let errorIdDirectBuy = '';

  // validate network countries
  const isInvalidNetworkCountries = formData[networkField]?.countries?.some((item) => {
    const isEmpty = (!item.minCpi || item.minCpi == 0) && (!item.minEcpm || item.minEcpm == 0);
    if (isEmpty) errorIdNetwork = item.cca2;
    return isEmpty;
  });

  if (isInvalidNetworkCountries) {
    setError(networkCountriesError, {
      type: 'custom',
      message: 'At least one field is required',
      cca2: errorIdNetwork,
    });
    return false;
  }

  // validate direct buy countries
  const isInValidDirectBuyCountries = formData[directBuyField]?.countries?.some((item) => {
    const isEmpty = !item.directCpi && item.directCpi == 0;
    if (isEmpty) errorIdDirectBuy = item.cca2;
    return isEmpty;
  });

  if (isInValidDirectBuyCountries) {
    setError(directBuyCountriesError, {
      type: 'custom',
      cca2: errorIdDirectBuy,
    });
    return false;
  }

  return true;
}
